import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { concat, merge, of, from, Subscription, Subject } from 'rxjs';
import { map, switchMap, concatMap, mergeMap, filter, repeat, tap, finalize, debounceTime, distinctUntilChanged, take } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { Document, DocItems, DocInheritanceRule } from 'src/app/shared/document';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { Product, ProductParts } from 'src/app/shared/product';

import { ProductApiService } from 'src/app/services/product-api.service';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { RestApiService } from '../../services/rest-api.service';
//import { typeofExpr } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-new-document-dlg-process-spec',
  templateUrl: './new-document-dlg-process-spec.component.html',
  styleUrls: ['./new-document-dlg-process-spec.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgProcessSpecComponent implements OnInit, OnChanges, OnDestroy {

  private globalSettinsData: GlobalSettingsData;
  private _productInfoQuery: Subscription;

  /*
   * Consider that parentDocument may have or may NOT have items property filled with [actual] docItems
   */
  @Input() parentDocument: Document;

  /*
   * Therefore, to keep source object untouched (immutable ????)
   * we will expect alone/independent copy of DocItems as Input parameter
   * 
   */

  @Input() docItems: DocItems[];

  @Input() newDocument: Document;

  @Input() newDocuments: Document[];

  public get hasParentDocument(): boolean { return (this.parentDocumentId && true); }

  parentDocumentId: number;

  count: number = -1;

  sourceDocItems: DocItems[];

  @Output() blocking: EventEmitter<boolean> = new EventEmitter();

  actions =
    [
      { name: 'Удалить существующие позиции', value: 3, disabled: false },
    ];

  warranty: string = '24 місяці';

  warrantyOptionsList = [
    { label: '2 тижні', value: '2 тижні' },
    { label: '1 місяць', value: '1 місяць' },
    { label: '3 місяці', value: '3 місяці' },
    { label: '6 місяців', value: '6 місяців' },
    { label: '12 місяців', value: '12 місяців' },
    { label: '18 місяців', value: '18 місяців' },
    { label: '24 місяці', value: '24 місяці' },
    { label: '36 місяців', value: '36 місяців' },
    { label: 'Довічна', value: 'Довічна' },
    { label: 'Нема', value: 'Нема' },
    { label: '', value: '' }
  ];

  selectedActions: any = [3];

  private processDocuments$ = new Subject<{ curId: number, insMode: string, selected: number }>();
  private currencyQuery: Subscription;

  blocked: boolean = false;

  insertMode: string = 'm1';

  selectedManufacturedItem: number;
  products: { prodid: number; prodname: string; }[] = [];

  public get thereIsManufacturedItems(): boolean { return ((this.products || []).length > 0); }
  public get itIsSpecification(): boolean { return (this.newDocument && (this.newDocument.DOCTYPE == 7)); }
  public get hasParentSpecification(): boolean { return (this.hasParentDocument && this.parentDocument && (this.parentDocument.DOCTYPE == 7)); }

  private createNewDocument$ = new Subject<Document>();
  private _creatNewDoc: Subscription;

  @Output() onCreateNewDocuments = new EventEmitter<Document[]>();

  constructor(
    private restApi: RestApiService,
    private prodApi: ProductApiService,
    private docApi: DocumentApiService,
    private globalsettingsservice: GetglobalsettingsService,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** NewDocumentDlgProcessSpecComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));

      switch (propName) {

        case 'newDocument':
          if (this.newDocument) {
            if (this.newDocument.DOCTYPE == 16) {
              this.insertMode = 'm5';
            }
            this.processDocItems();
          }
          break;

        case 'docItems':
          if (this.docItems) {
            this.sourceDocItems = [... this.docItems];
            this.count = this.sourceDocItems.length;
            this.processDocItems();
          }
          break;

        case 'parentDocument':
          if (this.parentDocument) {

            if (this.parentDocument.items) {
              this.processDocItems();
            }
          }
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgProcessSpecComponent in ngOnDestroy')

    if (this.currencyQuery) { this.currencyQuery.unsubscribe(); }

    if (this._productInfoQuery) { this._productInfoQuery.unsubscribe(); }
  }

  processDocItems() {
    console.log('*** NewDocumentDlgProcessSpecComponent in processDocItems');
    this.processDocuments$.next({ curId: this.newDocument.DOCCURRID, insMode: this.insertMode, selected: this.selectedManufacturedItem });
  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgProcessSpecComponent in ngOnInit');

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();
    /*
     * Get Actual currency rate for newDocument
     * Those one in newDocument.DOCRATEVAL from createNewDocument Dialog would arrive later
     * 
     */

    this._creatNewDoc =
      this.createNewDocument$

        .pipe(
          concatMap(ndi => of(ndi).pipe(map(d => { this.blocked = true; return d; }))),

          concatMap(ndi => concat(
            of(ndi).pipe(map(doc => {
              if (doc.items.length) {
                console.log('*** NewDocumentDlgProcessSpecComponent in ngOnInit C1');
                //environment.production || console.table(doc.items);

                /*
                 * Push only newDocument with content 
                 */
                this.newDocuments.push(doc);

                this.onCreateNewDocuments.emit(this.newDocuments);
              }
              this.blocked = false;

              return of(doc);
            }))
          )),
        )
        .subscribe();

    this.currencyQuery =
      this.processDocuments$
      .pipe(
        switchMap(opt => this.restApi.getCurrencyInfoByID(opt.curId).pipe(map(rate => {
          console.log('*** NewDocumentDlgProcessSpecComponent in concatMap(rate): opt=(' + JSON.stringify(opt) + ')');

          let rowSortIndex = 0;

          this.products =
            Array.from(
              new Set(
                this.sourceDocItems
                  .filter(di => (di.PRODKIND == 1))
                  .map(v => v.PRODID)
              )
            )
              .map(id => ({ prodid: id, prodname: this.sourceDocItems.find(v => id == v.PRODID).PRODCODE }));

          this.newDocuments = [];
          this.newDocument.DOCRATEVAL = rate[0].CURRATE;
          this.newDocument.items = [];

          switch (opt.insMode) {
            case 'm5':
              /*
               * Generate pasport (special case)
               */
              this._productInfoQuery =
                concat(
                  from(this.sourceDocItems)
                    .pipe(
                      map(di => {
                        console.log('*** NewDocumentDlgProcessSpecComponent IN opt.insMode=m5 (' + this.hasParentSpecification + ')');
                        console.log('*** NewDocumentDlgProcessSpecComponent IN opt.insMode=m5 (' + this.itIsSpecification + ')');

                        this.newDocument.items.push(
                          {
                            ...di,
                            ... {
                              DOCITEMID: -2,
                              cloneIndex: 0,
                              U4ETKA: null,
                              DOCITEMCURRID: this.newDocument.DOCCURRID,
                              DOCITEMCRATE: this.newDocument.DOCRATEVAL,
                              PAYITEMCLIID: (rowSortIndex += 10),
                              PRODVAT: di.PRODVAT ?? this.globalSettinsData.vatValue,
                              DOCITEMPRICE: 0,
                              DOCITEMVPRICE: 0,
                              DOCITEMQTY: 1,
                              DOCITEMSUM: 0,
                              DOCITEMTEXT1: (di.DOCTYPE == 7) ? di.DOCITEMTEXT1 : '',
                              DOCITEMTEXT2: (di.DOCTYPE == 7) ? di.DOCITEMTEXT2 : '',
                            }
                          }
                        );
                      }),
                      finalize(() => {
                        this.createNewDocument$.next(this.newDocument);
                      })),
                )
                  .subscribe();
              break;

            case 'm1':
              this._productInfoQuery =
                concat(
                  from(this.sourceDocItems)
                    .pipe(
                      filter(di => ((di.DOCITEMQTY > 0) && (di.PRODKIND == 0))),
                      map(di => {

                        for (var i = 0; i < di.DOCITEMQTY; ++i) {

                          this.newDocument.items.push(
                            {
                              ...di,
                              ... {
                                DOCITEMID: -2,
                                cloneIndex: 0,
                                U4ETKA: null,
                                DOCITEMCURRID: this.newDocument.DOCCURRID,
                                DOCITEMCRATE: this.newDocument.DOCRATEVAL,
                                PAYITEMCLIID: (rowSortIndex += 10),
                                PRODVAT: di.PRODVAT ?? this.globalSettinsData.vatValue,
                                DOCITEMPRICE: 0,
                                DOCITEMVPRICE: 0,
                                DOCITEMQTY: 1,
                                DOCITEMSUM: 0,
                                DOCITEMTEXT1: (di.DOCTYPE == 7) ? di.DOCITEMTEXT1 : '',
                                DOCITEMTEXT2: this.warranty,
                              }
                            }
                          );
                        }
                      }),
                      finalize(() => {
                        this.createNewDocument$.next(this.newDocument);
                      })),
                )
                  .subscribe();
              break;

            case 'm3':
              /*
                *  Insert all manufactured items into different documents
                */
              console.log('*** NewDocumentDlgProcessSpecComponent IN (3) insertMode=(' + opt.insMode + ')');
              this._productInfoQuery =
                from(this.sourceDocItems)
                  .pipe(
                    filter(di => ((di.DOCITEMQTY > 0) && (di.PRODKIND == 1))),

                    concatMap(di => this.prodApi.getProductById(di.PRODID).pipe(map(pr => {

                      this.blocked = true;

                      console.log('*** NewDocumentDlgProcessSpecComponent IN (3) recreate NewDocument for di: ' + di.PRODCODE);

                      this.newDocument.DOCNOTE1 = pr[0].PRODCODE;
                      this.newDocument.items = [];

                      return di;
                    }))),

                    concatMap(di => this.prodApi.getProdParts(di.PRODID).pipe(map(parts => {

                      parts.forEach(part => {
                        console.log('*** NewDocumentDlgProcessSpecComponent IN (3) about to push : ' + part.PARTCODE);

                        for (var pc = 0; pc < part.QUANTITY; ++pc) {

                          this.newDocument.items.push(
                            {
                              DOCITEMID: -2,
                              cloneIndex: 0,
                              DOCID: -2,
                              U4ETKA: null,
                              PRODID: part.PARTID,
                              PRODCODE: part.PARTCODE,
                              DOCITEMPRODNAME: part.PARTNAME,
                              DOCITEMCURRID: this.newDocument.DOCCURRID,
                              DOCITEMCRATE: this.newDocument.DOCRATEVAL,
                              PAYITEMCLIID: (rowSortIndex += 10),
                              DOCITEMPRICE: 0,
                              DOCITEMVPRICE: 0,
                              DOCITEMQTY: 1,
                              DOCITEMSUM: 0,
                              DOCITEMTEXT1: '',
                              DOCITEMTEXT2: this.warranty,
                              PAYITEMDEPID: 0,
                              CURCODE: ''
                            }
                          );
                        }
                      });

                      for (var count = 0; count < di.DOCITEMQTY; ++count) {
                        this.createNewDocument$.next({ ... this.newDocument });
                      }
                    }))),

                    finalize(() => {
                      console.log('*** NewDocumentDlgProcessSpecComponent IN (3) finalize: ');
                      this.blocked = false;
                    })
                  )
                  .subscribe();
              break;

            case 'm4':
              /*
                *  Insert selected manufactured item document
                */
              this._productInfoQuery =
                from(this.sourceDocItems)
                  .pipe(
                    filter(di => (di.PRODID == this.selectedManufacturedItem)),

                    // Here we come with source DocItems pointed to manufactured item.
                    // Let's decompose them into parts and insert it into new document

                    concatMap(di => this.prodApi.getProductById(di.PRODID).pipe(map(pr => {

                      this.newDocument.items = [];
                      this.newDocument.DOCNOTE1 = pr[0].PRODCODE;

                      return di;
                    }))),

                    concatMap(di => this.prodApi.getProdParts(di.PRODID)),

                    concatMap(pp => from(pp).pipe(

                      concatMap(ppart => this.prodApi.getProductById(ppart.PARTID).pipe(
                        concatMap(prod => {
                        let part: Product = prod[0];

                        for (var pc = 0; pc < ppart.QUANTITY; ++pc) {

                          this.newDocument.items.push(
                            {
                              DOCITEMID: -2,
                              cloneIndex: 0,
                              DOCID: -2,
                              U4ETKA: null,
                              PRODID: part.PRODID,
                              PRODCODE: part.PRODCODE,
                              DOCITEMPRODNAME: part.PRODNAME,
                              DOCITEMCURRID: this.newDocument.DOCCURRID,
                              DOCITEMCRATE: this.newDocument.DOCRATEVAL,
                              PAYITEMCLIID: (rowSortIndex += 10),
                              PRODVAT: part.PRODVAT ?? this.globalSettinsData.vatValue,
                              DOCITEMPRICE: 0,
                              DOCITEMVPRICE: 0,
                              DOCITEMQTY: 1,
                              DOCITEMSUM: 0,
                              DOCITEMTEXT1: '',
                              DOCITEMTEXT2: this.warranty,
                              PAYITEMDEPID: 0,
                              CURCODE: ''
                            }
                          );
                          }
                          return of(ppart);
                      })))
                    )),
                    finalize(() => {
                      this.createNewDocument$.next(this.newDocument);
                    })
                  )
                  .subscribe();
              break;

            case 'm2':
            default:
              this._productInfoQuery =
                from(this.sourceDocItems)
                  .pipe(
                    filter(di => (di.DOCITEMQTY > 0)),
                    map(di => {
                      for (var i = 0; i < di.DOCITEMQTY; ++i) {

                        this.newDocument.items.push(
                          {
                            ...di,
                            ... {
                              DOCITEMID: -2,
                              cloneIndex: 0,
                              U4ETKA: null,
                              DOCITEMCURRID: this.newDocument.DOCCURRID,
                              DOCITEMCRATE: this.newDocument.DOCRATEVAL,
                              PAYITEMCLIID: (rowSortIndex += 10),
                              PRODVAT: di.PRODVAT ?? this.globalSettinsData.vatValue,
                              DOCITEMPRICE: 0,
                              DOCITEMVPRICE: 0,
                              DOCITEMQTY: 1,
                              DOCITEMSUM: 0,
                              DOCITEMTEXT1: '',
                              DOCITEMTEXT2: this.warranty,
                            }
                          }
                        );
                      }
                    }),
                    finalize(() => {
                      this.createNewDocument$.next(this.newDocument);
                    })
                  )
                  .subscribe();
              break;
          }
          return opt;

        }))),

        concatMap(opt => {


          console.log('*** NewDocumentDlgProcessSpecComponent insertMode=(' + opt.insMode + ')');

          return of(opt);
        })
      )
      .subscribe();
    this.processDocItems();
  }

  onSelectedItemChange(event) {
    console.log('*** NewDocumentDlgProcessSpecComponent onSelectedItemChange ' + JSON.stringify(event));

    this.processDocItems();
  }

  onInsertModeSelect(event) {
    console.log('*** NewDocumentDlgProcessSpecComponent onInsertModeSelect ' + JSON.stringify(event));

    this.processDocItems();
  }

  onDocTypeChanges(event) {
    console.log('*** NewDocumentDlgProcessSpecComponent onDocTypeChanges ' + JSON.stringify(event));

    this.processDocItems();
  }

  onClearRows(event) {
    console.log('*** NewDocumentDlgProcessSpecComponent onClearRows ' + JSON.stringify(event));

    this.newDocument.items = [];
  }

  onRefreshRows(event) {
    console.log('*** NewDocumentDlgProcessSpecComponent onRefreshRows ' + JSON.stringify(event));

    this.processDocItems();
  }
}
